export const updatePosition=(options)=>{
    const otherOption = "Others" ; // The option that should be moved to the end
          const filteredOptions = options.filter(option => option !== otherOption);
          const otherOptionAtEnd = options.includes(otherOption) ? [otherOption] : [];
          
          // Combine the filtered options with "Others" at the end
          return([...filteredOptions, ...otherOptionAtEnd]);
    
    //      
}